import {DataStore} from 'aws-amplify';
import {UpdateContractInput} from 'src/app/API.service';
import {BehaviorSubject} from 'rxjs';
import {DateTime, Settings} from 'luxon';
import {ContractStatus} from '../enums/enums';
import {Bonus, BonusType, Contract, PermissionType, User} from '../../models';

export class CareerController {
    get selectedyear(): string {
        return this._selectedyear;
    }

    set selectedyear(value: string) {
        this._selectedyear = value;
    }

    get selectedMonth(): string {
        return this._selectedMonth;
    }

    set selectedMonth(value: string) {

        this._selectedMonth = value;
        this.recalcolaMensile();
    }

    get selectedQuarter(): string {
        return this._selectedQuarter;
        this.recalcolaAnnuale();
    }

    set selectedQuarter(value: string) {
        this._selectedQuarter = value;
    }


    careers: Career[] = [
        {
            title: 'Excutive Advisor',
            amount: 5000,
            max: 10000,
            percent: 50,
        }, {
            title: 'Senior Advisor',
            amount: 10000,
            max: 30000,
            percent: 55,
        }, {
            title: 'Leader Advisor',
            amount: 30000,
            max: 60000,
            percent: 60,
        },
        {
            title: 'Excutive Manager',
            amount: 60000,
            max: 120000,
            percent: 65,
        }, {
            title: 'Senior Manager',
            amount: 120000,
            max: 250000,
            percent: 70,
        }, {
            title: 'Leader Manager',
            amount: 250000,
            max: 500000,
            percent: 75,
        }, {
            title: 'Excutive Director',
            amount: 500000,
            max: 750000,
            percent: 80,
        }, {
            title: 'Senior Director',
            amount: 750000,
            max: 1000000,
            percent: 85,
        }, {
            title: 'Leader Director',
            amount: 1000000,
            max: 100000000,
            percent: 90,
        },
    ];
    private user: User;
    private career: Career;
    private instance: this;
    private contracts: Contract[];
    private carriera;
    public years = [];
    private _selectedyear = new Date().getFullYear().toString();
    private _selectedQuarter = DateTime.now().get('month').toString();
    private _selectedMonth = DateTime.now().get('month').toString();
    monthes = {
        '01': 'Gennaio',
        '02': 'Febbraio',
        '03': 'Marzo',
        '04': 'Aprile',
        '05': 'Maggio',
        '06': 'Giugno',
        '07': 'Luglio',
        '08': 'Agosto',
        '09': 'Settembre',
        '10': 'ottobre',
        '11': 'Novembre',
        '12': 'Dicemebre',
    };
    quartrs: {
        '1': 'Gen - Mar',
        '2': 'Apr - Giu',
        '3': 'Lug - Set',
        '4': 'Ott - Dec',
    };
    // TODO Carriera datttuale del utente


    // TODO gian: lista contratti mensili

    public teamBonus3$ = new BehaviorSubject(0);
    public marketingFee1$: BehaviorSubject<{ total: number, bonuses: Bonus[] }> = new BehaviorSubject<{ total: number, bonuses: Bonus[] }>({
        total: 0,
        bonuses: [],
    });
    public mmanagerFee2$: BehaviorSubject<{ total: number, bonuses: Bonus[] }> = new BehaviorSubject<{ total: number, bonuses: Bonus[] }>({
        total: 0,
        bonuses: [],
    });
    public totalTeamRevenue$ = new BehaviorSubject(undefined);
    public contracts$ = new BehaviorSubject<Contract[]>(undefined);
    public careerTitle$ = new BehaviorSubject(undefined);
    public nextCareerTitle = new BehaviorSubject(undefined);
    public careerProgress$ = new BehaviorSubject<CareerProgress[]>([]);
    public totalRevnue$ = new BehaviorSubject<number>(0);
    public revenueFee4$ = new BehaviorSubject(0);
    sposnerFee5$ = new BehaviorSubject(0);
    leaderBonus6$ = new BehaviorSubject(0);
    ambassadorBonus7$ = new BehaviorSubject(0);
    companyBonus8$ = new BehaviorSubject(0);
    companyBonus9$ = new BehaviorSubject(0);


    constructor(user: User) {
        if (this.instance && this.instance?.user == user) {
            return this;
        }
        let year = JSON.parse(JSON.stringify(this._selectedyear));
        this.years = [];
        while (year > 2019) {
            this.years.push(year);
            year = year - 2;
        }
        this.user = user;

        if (this.user == undefined) {
            return;
        }
        const d = DateTime.now();
        
        this.setTeamBonus();
        
        this.initUserData();

        this.instance = this;
    }

    async setAmbassadorBonus7() {
        let c = await DataStore.query(Contract, c => c.clientId('eq', this.user.id));

        c = c.filter(m => {
            //  return m.userContractsAddedId == this.user.id;
            return m.commercial?.id == this.user.id;
        });
        let t = 0;
        c.forEach(x => {
            t = t + x.amount;
        });
        this.ambassadorBonus7$.next(t);

    }

    initUserData() {


        DataStore.query(Contract,
            c => c.status('eq', ContractStatus.ACTIVE).startDate('contains', this._selectedyear),
        ).then(v => {

            v = v.filter(
                x => x.commercial.id == this.user.id,
                //    x => x.userContractsAddedId == this.user.id
            );
            
            this.contracts$.next(v);
        });
        this.contracts$.subscribe((m: Contract[]) => {
            if (m && m.length > 0) {
                let totalContarctsValue = 0;
                m.forEach(v => {
                    totalContarctsValue = totalContarctsValue + v.amount;
                });
                
                this.totalRevnue$.next(totalContarctsValue);
                const c = [];
                for (const carrer of this.careers) {
                    

                    if (totalContarctsValue > carrer.amount && totalContarctsValue < carrer.max) {
                        this.careerTitle$.next(carrer.title);
                        this.career = carrer;
                        c.push({
                            career: carrer,
                            percent: Number((totalContarctsValue / carrer.max)).toFixed(2),

                        });
                    } else if (totalContarctsValue < carrer.amount) {
                        c.push({
                            career: carrer,
                            percent: Number((totalContarctsValue / carrer.max)).toFixed(2),

                        });
                    } else {
                        c.push({
                            career: carrer,
                            percent: 1,
                        });
                    }
                }
                
                this.careerProgress$.next(c);

                /**
                 * set bonus
                 */

                this.setRevenueFee();
                this.setSponserFee();
                this.setManegerFee2();
            }
        });
        this.setAmbassadorBonus7();
        this.setMarketingFee1();


        this.setLeaderFee();

    }

    async setRevenueFee() {
        var now = new Date();
        var quarter = this.getQuarter(now);
        var firstDate = new Date(now.getFullYear(), quarter * 3, 1);
        var endDate = this.getLastDayOfQuarter(now);


        let c = await DataStore.query(Contract, l => l.startDate('contains', '2021'));
        c = c.filter(
            //   t => t.userContractsAddedId == this.user.id
            t => t.commercial.id == this.user.id,
        );
        //TODO aggiungi date
        

        let total = 0;
        let b = 0;


        // eslint-disable-next-line @typescript-eslint/no-shadow
        c = c.filter(x => {
            return x.startDate >= this.dateToAwsString(firstDate) && x.endDate <= this.dateToAwsString(endDate);
        });
        for (const contract of c) {
            total = total + contract.amount;
        }

        // @ts-ignore
        
        if (total <= 100000) {
            b = total / 100000;
        } else if (total > 100000 && total <= 200000) {
            b = (total * 0.5) / 100;

        } else if (total > 200000 && total <= 300000) {
            b = (total * 0.75) / 100;
        } else if (total > 300000 && total <= 400000) {
            b = (total * 1) / 100;
        } else if (total > 400000 && total <= 500000) {
            b = (total * 1.25) / 100;
        } else if (total > 500000) {
            b = (total * 1.5) / 100;
        }

        this.revenueFee4$.next(b);

    }

    setSponserFee() {
        this.contracts$.subscribe(async c => {


            const users = await DataStore.query(User,
                condition => condition.addedBy('eq', this.user.id),// TODO uncomment after test
            );
            //  users = users.filter(u => u.userContractsAddedId == this.user.id);

            let total = 0;
            let b = 0;
            let usersTotal = [];
            let i = 0;
            for (const u of users) {
                if (i > 5)
                    break;
                const userContracts = await DataStore.query(Contract,
                    t => t.clientId('eq', u.id),// TODO uncomment after test
                );
                // eslint-disable-next-line @typescript-eslint/no-shadow

                for (const contract of userContracts) {
                    total = total + contract.amount;
                }
                i++;
                usersTotal.push({...JSON.parse(JSON.stringify(u)), total: total});
            }
            // @ts-ignore

            if (total <= 100000) {
                this.sposnerFee5$.next(total / 100000);
                return;
            } else if (total > 100000 && total <= 200000) {
                b = (total * 0.5) / 100;

            } else if (total > 200000 && total <= 300000) {
                b = (total * 0.75) / 100;
            } else if (total > 300000 && total <= 400000) {
                b = (total * 1) / 100;
            } else if (total > 400000 && total <= 500000) {
                b = (total * 1.25) / 100;
            } else if (total > 500000) {
                b = (total * 1.5) / 100;
            }

            this.sposnerFee5$.next(b);
        });
    }

    afterContractAdd() {

    }


    async setTeamBonus() {
        const d = this.dateToAwsString(this.getFisrtDayOfCurrentMonth());
        const items = await DataStore.query(Contract, c => c.clientId('eq', this.user.id));


        let total = 0;
        let partecipatedCommercialNumber = 0;
        let b = 0;

        let atLeastTwo = false;
        // @ts-ignore
        for (const c: UpdateContractInput of items) {
            total = total + c.amount;
        }
        
        if (total < 10000) {

            this.teamBonus3$.next(total / 10000);
            return;
        }
        const users = await DataStore.query(User, c => c.teamID('eq', this.user.teamID).id('ne', this.user.id).permessions('ne', PermissionType.CLIENT));
        
        let totalPersonale = JSON.parse(JSON.stringify(total));
        for (const user of users) {
            let t = 0;
            let contracts = await DataStore.query(Contract, c => c.clientId('eq', user.id));
            contracts = contracts.filter(c => c.startDate >= d);

            
            for (const contract of contracts) {
                t = t + contract.amount;
            }
            
            if (t >= 10000) {
                partecipatedCommercialNumber = partecipatedCommercialNumber + 1;

                total = total + t;
            }
        }

        if (partecipatedCommercialNumber == 0) {
            this.teamBonus3$.next(0);
            return;
        }
        total = total / partecipatedCommercialNumber;

        if (total > 10000 && total <= 20000) {
            b = 0.5;

        } else if (total > 20000 && total < 30000) {
            b = 1;
        } else if (total > 30000) {
            b = 1.5;
        }
        
        let ret = (totalPersonale * b) / 100;
        this.teamBonus3$.next(ret);

        // TODO ritorna il il valore del team bounos se è disponibile oppure null
        // TODO Aggiungere controllo 2 persone del team
    }

    // requisito 30%
    async setLeaderBonus6() {

    }

    getSponserFeeBonus() {
        // TODO ritorna il il valore del team bounos se è disponibile oppure null
        // diretti 5 commerciali
    }

    getCompanyBonus() {

    }


    /**
     * ritorna il totale dei contratti dei commerciali diretti
     * @limitTopNumber = -1 // tutto il team
     */
    getTotalContractsOfDownline(limitTopNumber = 5) {

    }


    async getContracts() {
        const l = await DataStore.query(Contract,
            // , c => c.userID('eq', this.user.id),
        );
        return l;
    }

    private setLeaderFee() {

    }

    async setMarketingFee1() {
        DataStore.query(Bonus, condition =>
            //condition.userBonusId('eq', this.user.id)
            // condition.userBonusId('eq', this.user.id)
            condition.type('eq', BonusType.MARKETING_FEE_1),
        ).then(async bonust => {


            let bonus = bonust.filter(u => u.user?.id == this.user.id);
            let t: number;
            t = 0;
            let b = [];
            for (const bonus1 of bonus) {
                t = t + bonus1.total;
                const c = await DataStore.query(Contract, bonus1.contractId);
                /* b.push({
                         name:c.client.lastname +" "+c.client.name,
                     total: bonus1.total
                 })*/
            }
            // @ts-ignore
            this.marketingFee1$.next({
                total: t,
                bonuses: bonus,
            });
            
        });

    }

    async setManegerFee2() {
        DataStore.query(Bonus, condition => condition
                //.userBonusId('eq', this.user.id)
                .payDate('ge', this.getFisrtDayOfCurrentMonth().toISOString())
                .type('eq', BonusType.MANAGER_FEE_2))
            .then(async bonustemp => {
                let bonus = bonustemp.filter(y => y.user?.id);
                
                let t: number;
                t = 0;
                let b = [];
                for (const bonus1 of bonus) {
                    t = t + bonus1.total;

                    /* b.push({
                             name:c.client.lastname +" "+c.client.name,
                         total: bonus1.total
                     })*/
                }
                // @ts-ignore
                this.mmanagerFee2$.next({
                    total: t,
                    bonuses: bonus,
                });
                
            });

    }

    getFisrtDayOfCurrentMonth(d = null) {
        if (!d)
            d = DateTime.now();
        var date = new Date(d);
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    dateToAwsString(d) {
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }

    getQuarter(d) {
        d = d || new Date();
        let m = Math.floor(d.getMonth() / 3) + 2;
        return m > 4 ? m - 4 : m;
    }

    getLastDayOfQuarter(date) {
        let year = date.getFullYear();
        let quarterEndings = [[3, 31], [6, 30], [9, 30], [12, 31]];

        let toDateObj = function (dates) {
            return new Date(year, dates[0] - 1, dates[1]);
        };

        let isBeforeEndDate = function (endDate) {
            return endDate >= date;
        };

        date.setHours(0, 0, 0, 0);

        return quarterEndings
            .map(toDateObj)
            .filter(isBeforeEndDate)[0];
    }

    changeYear(year) {
        

        this._selectedyear = year;
        
        this.initUserData();
    }

    private recalcolaMensile() {

    }

    private recalcolaAnnuale() {

    }
    public  getSelectedYear(){
        return this._selectedyear;
    }

    changeMonth($event: Event) {
        
    }
}

export type CareerProgress = {
    career: Career,
    percent: number
};
export type Career = {
    title: string;
    percent: number;
    max: number,
    amount: number;
};
